import { Headset } from 'lucide-react';
import Tooltip from '../ToolTip';

interface IReportIconProps {
  onClick?: () => void;
}

const ReportIcon = ({ onClick }: IReportIconProps) => {
  return (
    <div className='relative'>
      <Tooltip placement="bottom" bgColor="bg-gray-200" message="Contact support">
        <div className="h-8 w-8 rounded-full flex items-center justify-center bg-white hover:bg-primary-main ease-in-out duration-200	">
          <Headset height={'16px'} width={'16px'} onClick={onClick} />
        </div>
      </Tooltip>
    </div>
  );
};

export default ReportIcon;
